import { NgModule } from "@angular/core";
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from "app/shared/shared.module";
import { ActionButtonsModule } from "../action-buttons/action-buttons.module";
import { JsxModule } from "../jsx/jsx.module";
import { ViewButtonsModule } from "../view-buttons/view-buttons.module";
import { BreadCrumbFlatplanToolbarComponent } from "./bread-crumb-flatplan-toolbar/bread-crumb-flatplan-toolbar.component";
import { BreadCrumbMenuComponent } from "./bread-crumb-menu/bread-crumb-menu.component";
import { BreadcrumbComponent } from "./breadcrumb.component";

@NgModule({
    imports: [SharedModule, ViewButtonsModule, ActionButtonsModule,NgbAlertModule, JsxModule],
    declarations: [BreadcrumbComponent, BreadCrumbMenuComponent, BreadCrumbFlatplanToolbarComponent],
    exports: [BreadcrumbComponent],
})
export class BreadcrumbModule {}
